import {useCallback, useEffect, useState} from 'react';

import {referralService} from '@/services/referralService';
import type {AfriexReferralTier} from '@/types';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

import type {TierListProps} from './types';

const useEventTierList = (): TierListProps<AfriexReferralTier> => {
  const [tierList, setTierList] = useState<AfriexReferralTier[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [itemTotal, setItemTotal] = useState<number>(0);
  const [page, setPage] = useState<number>(0);
  const [error, setError] = useState<unknown>(null);

  const fetchTierList = useCallback(async (params: AfriexQueryParams) => {
    try {
      setError(null);
      setIsLoading(true);
      const {data: tiers, total} =
        await referralService.getEventCodeList(params);
      setTierList(tiers);
      setItemTotal(total || 0);
    } catch (e) {
      setError(e);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    // Fire-and-forget: fetchTierList try/catches, stores the failure in
    // `error` and clears `isLoading`, so this only stops an unexpected throw
    // becoming an unhandled rejection.
    fetchTierList({}).catch(() => {});
  }, [fetchTierList]);

  return {
    error,
    fetchList: fetchTierList,
    isLoading,
    page,
    setPage,
    total: itemTotal,
    list: tierList,
  };
};

export default useEventTierList;
